/* Custom cursor — a labelled circle that follows the pointer over elements
   marked data-cursor="true".

   The position is applied directly on every pointer event, with no easing and
   no animation loop: a trailing circle has to travel to the pointer, and when
   an element scrolls under a still mouse it would start that journey from
   wherever it last was. Only the scale is animated, with a short delay, so the
   circle is already in the right place by the time it becomes visible.

   Attributes on the hovered element:
     data-cursor="true"          enable the effect
     data-cursor-text            label inside the circle
     data-cursor-color           circle background
     data-cursor-color-text      label colour */
(function () {
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduced) return;

  var cursor = document.querySelector('[data-custom-cursor]');
  if (!cursor) return;

  var label = cursor.querySelector('[data-custom-cursor-text]');
  var hideTimeout = null;
  var lastX = 0;
  var lastY = 0;

  /* Position goes into left/top, never into transform — transform is reserved
     for the scale, which is the only thing allowed to animate. */
  function place(x, y) {
    lastX = x;
    lastY = y;
    cursor.style.left = x + 'px';
    cursor.style.top = y + 'px';
  }

  /* mouseover is in the list next to mousemove on purpose: scrolling a hotspot
     under a still mouse fires it, while mousemove never comes. */
  function track(e) {
    if (typeof e.clientX !== 'number') return;
    place(e.clientX, e.clientY);
  }

  document.addEventListener('mousemove', track, { passive: true });
  document.addEventListener('mouseover', track, { passive: true });

  function bind(root) {
    (root || document).querySelectorAll('[data-cursor="true"]').forEach(function (el) {
      if (el.dataset.cursorBound === 'true') return;
      el.dataset.cursorBound = 'true';

      el.addEventListener('mouseenter', function (e) {
        clearTimeout(hideTimeout);

        if (typeof e.clientX === 'number') place(e.clientX, e.clientY);
        else place(lastX, lastY);

        if (label) {
          label.textContent = el.getAttribute('data-cursor-text') || '';
          label.style.color = el.getAttribute('data-cursor-color-text') || '';
        }
        cursor.style.backgroundColor = el.getAttribute('data-cursor-color') || '';
        cursor.classList.add('is-active');
      });

      el.addEventListener('mouseleave', function () {
        hideTimeout = setTimeout(function () {
          cursor.classList.remove('is-active');
        }, 200);
      });
    });
  }

  bind();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
